
EMRAdmin.service("GoogleCommonService", GoogleCommonService);

GoogleCommonService.$inject = ["$http", "$q", '$exceptionHandler'];


/**
 * This is the service resposible for handling HTTP requests through out the application.
 * @param {any} $http
 * @param {any} $q
 */
function GoogleCommonService($http, $q, $exceptionHandler) {

    var serviceObj = {
        handleGoogleUrlsData: handleGoogleUrlsData,
        handleResponse: handleResponse,
        handleResponseError: handleResponseError,
    }
    return serviceObj;

    function handleGoogleUrlsData(requestMethod, targetUrl, inputData, azureFunctionToken, timeout) {
        debugger;
        if (_.isEmpty(inputData)) {
            inputData = {}
        }
        // var defer = $q.defer();

        // var azureFunctionToken = "ZQsPdf/Vavvrpb2NbP5jZC8sZfeMJuupsFjU9G6XielN8f4B3hjfcWK0wXCHQN/aVumTsoeHpaRgLxrosSDkrw==";
        inputData.PracticeID = EMRPracticeModel.PracticeID;
        inputData.LoggedUserID = EMRPracticeModel.LoggedUserID;
        inputData.DBServerName = EMRPracticeModel.DBServerName;
        inputData.IsLoggedUserInSupportRole = EMRPracticeModel.IsLoggedUserInSupportRole;

        $http({
            method: requestMethod,
            url: targetUrl,
            data: inputData,
            timeout: timeout && timeout > 0 ? timeout : 60000,
            headers: { 'Authorization': 'Bearer ' + azureFunctionToken },
           
        }).then(function (response) {
            return $q.resolve(response);
        }).catch(function (error) {
            return handleResponse(error, false)
        });

        // return defer.promise;

    }




    function handleResponse(actualResponse, isSuccess) {

        var response = actualResponse.data;

        //if it is in old format
        //we don't have 'data' property
        if (!response || !response.hasOwnProperty("data")) {
            if (isSuccess === false) {
                //return $q.reject(response);
                return handleResponseError(actualResponse);
            }
            return $q.resolve(response);
        }

        //handling new format errors  by data annotations
        if (actualResponse.status == 400) {
            if (response.errors && Object.keys(response.errors).length) {
                response.data = response.data || {};
                response.data["_emrIsError"] = true;
                response.data["_emrErrorMessage"] = JSON.stringify(response.errors);
                return $q.resolve(response.data);
            }
        }

        //handling new format errors
        if (response.hasOwnProperty("data")) {
            response.data = response.data || {};
            if (response.IsError) {
                response.data["_emrIsError"] = true;
                response.data["_emrErrorMessage"] = response.ErrorMessage;
            } else {
                response.data["_emrIsError"] = false;
            }
            return $q.resolve(response.data);
        }

        // return $q.reject(response);
        return handleResponseError(actualResponse);
    }

    function handleResponseError(actualResponse) {
        let config = actualResponse.config || {};
        $exceptionHandler(new Error('API Error'), {
            status: actualResponse.status,
            url: config.url || "",
            inputJson: config.data || ""
        });
        return $q.reject(actualResponse.data);
    }



}